module.exports = __webpack_public_path__ + "resources/img/solution_finance_rescue_v2.dc65579ab3f4f97b24dca91a892ec04d.png";